module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_2-5e6a23ae38e197ce8b91576193c1ef67.jpg";